import { render, staticRenderFns } from "./PrintLTA.vue?vue&type=template&id=987d8552&"
import script from "./PrintLTA.vue?vue&type=script&lang=js&"
export * from "./PrintLTA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports